import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet, View } from 'react-native';
import { theme } from '@xbto/design-system';
import { Button, Col, Row, TextBody, TextTitle } from '../../atoms';
export const ModalHeader = ({ title, subtitle, titleLeft, onClose, onBack, }) => {
    const RootEl = !onBack && !onClose ? Row.C : Row.LR;
    const TitleEl = titleLeft ? Col.L : Col.C;
    return (_jsxs(RootEl, { style: $.container, children: [onBack ? (_jsx(Button, { size: "sm", borderRadius: "md", variant: "tertiary", icon: "ArrowBack", style: $.action, onPress: onBack })) : titleLeft ? null : (_jsx(View, { style: $.action })), _jsxs(TitleEl, { style: $.titleContainer, children: [_jsx(TextTitle, { color: "primary", em: true, small: true, children: title }), subtitle ? (_jsx(TextBody, { center: true, color: "secondary", children: subtitle })) : null] }), onClose ? (_jsx(Button, { size: "sm", borderRadius: "md", variant: "tertiary", icon: "Close", style: $.action, onPress: onClose })) : (_jsx(View, { style: $.action }))] }));
};
const $ = StyleSheet.create({
    container: {
        padding: theme.spacing['6'],
        paddingBottom: 0,
        marginBottom: theme.spacing['8'],
    },
    titleContainer: {
        flexShrink: 1,
    },
    action: {
        minHeight: 24,
        width: 24,
        height: 24,
    },
});
